// Okna wyłączenia promocji prywatnych ubezpieczeń (tvp.uspartner.pl):
// w tych dniach nie pokazujemy ani popupu OfferPromoModal, ani bocznych
// kafelków SidebarPromoCards. Daty lokalne (dzień włącznie, od 00:00 do 23:59).
// Po ostatnim dniu okna promocja wraca sama – nic nie trzeba wdrażać.
export const PROMO_BLACKOUTS = [
  { from: '2026-10-22', to: '2026-10-23' } // czwartek–piątek, decyzja 19.10.2026
];

const pad = (value) => String(value).padStart(2, '0');

const toLocalIsoDate = (date) =>
  `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;

export const isPromoBlackout = (now = new Date()) => {
  const today = toLocalIsoDate(now);

  return PROMO_BLACKOUTS.some(({ from, to }) => today >= from && today <= to);
};
